import { useState } from "react";
import { Check, Copy } from "lucide-react";

export const CopyField = ({ label, value, testId }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (e) {
      if (process.env.NODE_ENV === "development") {
        console.warn("Clipboard copy blocked by the browser", e);
      }
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };
  return (
    <div className="min-w-0">
      <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
        {label}
      </div>
      <div className="mt-1.5 flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
        <code
          className="min-w-0 flex-1 truncate font-mono text-[13px] text-slate-800"
          data-testid={testId}
        >
          {value}
        </code>
        <button
          type="button"
          onClick={copy}
          data-testid={`${testId}-copy`}
          className="shrink-0 rounded p-1 text-slate-500 transition-colors duration-200 hover:bg-white hover:text-blue-600"
          aria-label={`Copy ${label}`}
        >
          {copied ? (
            <Check className="h-4 w-4 text-emerald-600" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  );
};
